module.exports = __webpack_public_path__ + "img/gsk.5f13f6e2.png";